<template>
  <div class="specialFeatures" v-if="special_list.length">
    <div class="title">
      <strong>特色专场</strong>
      <div class="indicatorFlex">
        <template v-for="index in special_list.length">
          <span
            class="indicator"
            :class="active === index ? 'active' : ''"
            :key="index"
            @mouseenter="onEnterTd(index)"
            @mouseleave="onLeaveTd"
          ></span>
        </template>
      </div>
    </div>
    <div class="content" v-if="special_list.length">
      <el-carousel
        ref="carouselRef"
        indicator-position="none"
        arrow="never"
        @change="change"
        :autoplay="autoplay"
        height="200px"
      >
        <template v-for="item in special_list">
          <el-carousel-item :key="item.ArtNum">
            <div class="specialList">
              <div class="imgUrl">
                <a :href="item.SpecialLink" target="_blank">
                  <el-image :src="item.SpecialCover">
                      <div slot="placeholder" class="image-slot">
                          加载中<span class="dot">...</span>
                      </div>
                      <div slot="error" class="el-image__error">
                          <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                      </div>
                  </el-image>
                </a>
              </div>
              <div class="main">
                <h1 class="title"><a :href="item.SpecialLink" target="_blank">{{ item.SpecialName }}</a></h1>
                <div class="common"><span style="color:#999;">拍品总数：</span>{{ item.ArtNum }}</div>
                <div class="common"><span style="color:#999;">拍卖时间：</span>{{ item.AuctionTime }}</div>
                <div class="common"><span style="color:#999;">拍卖地点：</span>{{ item.AuctionPlace }}</div>
              </div>
              <div v-if="item.art_list.length" class="list">
                <template v-for="data in item.art_list">
                  <div class="WorkCoverpic" :key="data.Ord">
                    <el-image :src="data.WorkCoverpic">
                        <div slot="placeholder" class="image-slot">
                            加载中<span class="dot">...</span>
                        </div>
                        <div slot="error" class="el-image__error">
                            <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                        </div>
                    </el-image>
                    <div class="WorkName">
                      {{ data.WorkName }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </el-carousel-item>
        </template>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "specialFeatures",
  props: ["special_list"],
  data() {
    return {
      active: 1,
      autoplay: true,
    };
  },
  methods: {
    change(i) {
      this.active = i + 1;
    },
    onEnterTd(i) {
      this.autoplay = false;
      this.$refs.carouselRef.setActiveItem(i - 1)
    },
    onLeaveTd() {
      this.autoplay = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.specialFeatures {
  margin-top: 30px;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 36px;
    border-top: 1px solid #ddd;
    strong {
      display: inline-block;
      padding-left: 10px;
      width: 115px;
      border-top: 3px solid #000;
      font-size: 16px;
    }
    .indicatorFlex {
      .indicator {
        display: inline-block;
        margin: 0 2px;
        width: 12px;
        height: 12px;
        border-radius: 6px;
        background-color: #dcdcdc;
        cursor: pointer;
      }
      .active {
        background-color: #000;
      }
    }
  }
  .content {
    .specialList {
      display: flex;
      width: 780px;
      height: 200px;
      background-color: #efefef;
      .imgUrl {
        width: 200px;
        height: 200px;
        overflow: hidden;
        .el-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: .5s;
          cursor: pointer;
          &:hover {
            transform: scale(1.1);
          }
        }
      }
      .main {
        padding-left: 10px;
        flex: 1;
        .title {
          font-size: 15px;
          font-weight: bold;
        }
        .common {
          line-height: 20px;
        }
      }
      .list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
        width: 200px;
        .WorkCoverpic {
          position: relative;
          width: 90px;
          height: 90px;
          overflow: hidden;
          cursor: pointer;
          transition: .3s;
          &:hover {
            .el-image {
              transition: .3s;
              transform: scale(1.1);
            }
            .WorkName {
              background-color: #000;
            }
          }
          .el-image {
            width: 90px;
            height: 90px;
            object-fit: cover;
          }
          .WorkName {
            position: absolute;
            bottom: 0;
            width: 100%;
            text-align: center;
            color: #fff;
            background-color: #808080;
          }
        }
      }
    }
  }
}
</style>
